import { getCrsFields } from './../../store/models/utils';
import {
  ADD_TAX_DETAILS,
  REMOVE_TAX_DETAILS,
  SET_LEGAL_FIRST_NAME,
  SET_LEGAL_LAST_NAME,
  SET_TAX_DETAILS,
  SET_TAX_STATUS,
} from './constants';

export const reducer = (state, action) => {
  let updatedState;
  switch (action.type) {
    case SET_TAX_STATUS:
      return { ...state, crsTaxStatus: action.value };
    case SET_TAX_DETAILS:
      return { ...state, crsTaxDetails: action.value };
    case ADD_TAX_DETAILS:
      updatedState = [...state.crsTaxDetails];
      updatedState.push(getCrsFields());
      return { ...state, crsTaxDetails: updatedState };
    case REMOVE_TAX_DETAILS:
      updatedState = [...state.crsTaxDetails];
      updatedState.splice(action.value.index, 1);
      return { ...state, crsTaxDetails: updatedState };
    case SET_LEGAL_FIRST_NAME:
      return { ...state, crsLegalFirstName: action.value };
    case SET_LEGAL_LAST_NAME:
      return { ...state, crsLegalLastName: action.value };
    default:
      return state;
  }
};
